var LOGISTICS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxOJQX1Wiud73SF0HVNObCm8WZhwUmw5d5Bryg8kMNru1Kv_zV5RC6nv5t0ghkHBM6W/exec';

window.BuyCoop = window.BuyCoop || {};
window.BuyCoop.logisticsIntake = window.BuyCoop.logisticsIntake || {};

function ensureLogisticsModalAtBodyLevel() {
  var modal = document.getElementById('logisticsIntakeModal');
  if (modal && modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }
}

function openLogisticsIntakeModal() {
  ensureLogisticsModalAtBodyLevel();

  var modal = document.getElementById('logisticsIntakeModal');

  if (modal) {
    modal.style.display = 'flex';
    modal.style.opacity = '1';
    modal.style.visibility = 'visible';
    modal.style.pointerEvents = 'auto';
    modal.style.zIndex = '999999';
    document.body.style.overflow = 'hidden';
  }
}

function closeLogisticsIntakeModal() {
  var modal = document.getElementById('logisticsIntakeModal');
  if (modal) {
    modal.style.display = 'none';
    modal.style.opacity = '';
    modal.style.visibility = '';
    modal.style.pointerEvents = '';
    modal.style.zIndex = '';
    document.body.style.overflow = '';
  }
}

window.openLogisticsIntakeModal = openLogisticsIntakeModal;
window.closeLogisticsIntakeModal = closeLogisticsIntakeModal;

window.BuyCoop.logisticsIntake.open = openLogisticsIntakeModal;
window.BuyCoop.logisticsIntake.close = closeLogisticsIntakeModal;

document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    closeLogisticsIntakeModal();
  }
});

document.addEventListener('click', function(event) {
  var trigger = event.target.closest('[data-bc-logistics-trigger]');
  if (trigger) {
    event.preventDefault();
    openLogisticsIntakeModal();
    return;
  }

  var closeButton = event.target.closest('[data-bc-logistics-close]');
  if (closeButton) {
    event.preventDefault();
    closeLogisticsIntakeModal();
    return;
  }

  var modal = event.target.closest('[data-bc-logistics-modal]');
  if (modal && event.target === modal) {
    closeLogisticsIntakeModal();
  }
});

document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('logisticsIntakeForm');
  var formStart = document.getElementById('form_start');

  if (formStart) {
    formStart.value = Date.now();
  }

  if (!form) return;

  form.addEventListener('submit', function(event) {
    event.preventDefault();

    var message = document.getElementById('logisticsIntakeMessage');
    var submitButton = form.querySelector('button[type="submit"]');

    if (!message || !submitButton) return;
    if (submitButton.disabled) return;

    submitButton.disabled = true;
    message.textContent = 'Submitting...';

    var payload = {
      name: document.getElementById('logisticsName')?.value || '',
      mobile: document.getElementById('logisticsMobile')?.value || '',
      pickup: document.getElementById('logisticsPickup')?.value || '',
      dropoff: document.getElementById('logisticsDropoff')?.value || '',
      schedule: document.getElementById('logisticsSchedule')?.value || '',
      load: document.getElementById('logisticsLoad')?.value || '',
      vehicle: document.getElementById('logisticsVehicle')?.value || '',
      notes: document.getElementById('logisticsNotes')?.value || '',
      page_url: window.location.href,
      submitted_at: new Date().toISOString(),
      source_context: 'logistics_intake_popup',
      website: document.getElementById('website')?.value || '',
      form_start: formStart?.value || ''
    };

    fetch(LOGISTICS_SCRIPT_URL, {
      method: 'POST',
      body: JSON.stringify(payload)
    })
    .then(() => {
      message.textContent = 'Request received. We’ll coordinate and follow up.';
      form.reset();
      if (formStart) formStart.value = Date.now();
    })
    .catch(() => {
      message.textContent = 'Error submitting request. Please try again.';
    })
    .finally(() => {
      submitButton.disabled = false;
    });
  });
});